<template>
<div>
  <FormInput label="Chat Id" :value="data.chat_id" hint="@channelusername or @groupusername or user_id" @update="data.chat_id=$event"></FormInput>
  <FormInput label="Message Id" :value="data.message_id" hint="Id of the message to edit" @update="data.message_id=$event"></FormInput>

  <div class="input-group mb-3">
    <div class="input-group-prepend">
      <span class="input-group-text">Media Type</span>
    </div>
    <select v-model="data.media.type" class="form-control">
        <option value="photo">Photo</option>
        <option value="video">Video</option>
        <option value="animation">GIF/Animation</option>
        <option value="audio">Audio</option>
        <option value="document">Document</option>
    </select>
  </div>
  <File :file="data.media.media" @updateFile="data.media.media = $event"></File>
  <Caption :text="data.media.caption" @updateCaption="data.media.caption=$event"></Caption>
  <ReplyMarkupInline :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup=$event"></ReplyMarkupInline>
</div>
</template>


<script>
import FormInput from '@/components/tasks/fields/FormInput.vue'
import File from '@/components/tasks/fields/File.vue'
import Caption from '@/components/tasks/fields/Caption.vue'
import ReplyMarkupInline from '@/components/tasks/fields/ReplyMarkupInline.vue'




export default {
  name: 'EditMessageMedia',
  components: {
    FormInput,
    File,
    Caption,
    ReplyMarkupInline
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{

  },
}
</script>
